import { render, staticRenderFns } from "./MoneyFieldDialog.vue?vue&type=template&id=22a42d8a&"
import script from "./MoneyFieldDialog.vue?vue&type=script&lang=js&"
export * from "./MoneyFieldDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports